import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { TERMS_EFFECTIVE_DATE } from '@floorpoll/shared';
import { Brand } from '../../components/Brand.js';

/**
 * Both documents share this frame. They sit outside every auth gate, so this
 * renders identically to a signed-out visitor, a signed-in user, and someone
 * reading them from inside the acceptance screen.
 */
export function LegalPage({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="legal-page">
      <header className="legal-head">
        <Brand to="/" />
      </header>

      <main className="legal">
        <h1>{title}</h1>
        <p className="legal-date">Last updated {TERMS_EFFECTIVE_DATE}</p>
        {children}
      </main>

      <footer className="legal-foot">
        <Link to="/">Back to FloorPoll</Link>
      </footer>
    </div>
  );
}
